import React, { forwardRef, useMemo } from "react";
import PropTypes from "prop-types";

import { Button, styled } from "@mui/material";
import { LoadingButton } from "@mui/lab";

const StyledBox = styled(
  forwardRef(function StyledBox(props, ref) {
    const { loading = false, loadingPosition = "center", ...other } = props;

    const classes = useMemo(() => {
      let cache = {
        disabled: "disabled",
        outlined: "outlined",
        loading: "loading",
        loadingIndicator: "loadingIndicator",
        loadingIndicatorCenter: "loadingIndicatorCenter",
      };

      if (!loadingPosition || loadingPosition === "center") {
        cache.loading += " indicatorCenter";
      }

      return cache;
    }, [loadingPosition]);

    return (
      <LoadingButton
        classes={classes}
        loadingPosition={loadingPosition}
        loading={loading}
        ref={ref}
        {...other}
      />
    );
  }),
)(({ theme, width, minWidth }) => ({
  width,
  minWidth,
  borderRadius: theme.shape.borderRadius / 2,
  padding: theme.spacing(1, 2),
  whiteSpace: "nowrap",
  // "&.disabled": {
  //   color: "rgba(0,0,0,0.26)",
  //   backgroundColor: "rgba(0,0,0,0.12)",
  //   boxShadow: "none",
  // },
  // "&.loading": {
  //   "&.indicatorCenter": {
  //     color: "transparent",
  //   },
  //   "& .loadingIndicator": {
  //     color: "rgba(0,0,0,0.5)",
  //   },
  // },
  // "&.outlined": {
  //   borderWidth: 2,
  // },
}));

StyledBox.propTypes = {
  ...Button.propTypes,
  loading: PropTypes.bool,
  loadingPosition: PropTypes.oneOf(["start", "end", "center"]),
  iconName: PropTypes.string,
};

export { StyledBox };
